import React, { Component } from 'react'
import Drawer from '@material-ui/core/Drawer'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import DeviceResetModal from './DeviceResetModal'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Icon from '@material-ui/core/Icon'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import humps from 'humps'

const styles = {
  docked: {
    height: '100%'
  },
  drawer: {
    position: 'relative',
    boxSizing: 'border-box',
    width: 275,
    paddingLeft: 50,
    height: '100%'
  },
  name: {
    fontSize: '1.5rem',
    padding: '40px 0'
  },
  tabName: {
    textTransform: 'capitalize'
  }
}

const tabs = {
  today: {
    icon: 'query_builder'
  },
  history: {
    icon: 'insert_chart_outlined'
  },
  vitalSigns: {
    icon: 'favorite'
  },
  personal: {
    icon: 'person'
  },
  treatments: {
    icon: 'trending_up'
  },
  notes: {
    icon: 'notes'
  },
}

class PatientSidebar extends Component {
  clickProps = (tab) => {
    return {
      selected: humps.camelize(this.props.selectedTab) === tab,
      onClick: e => this.props.switchTabs(humps.decamelize(tab, { separator: '-'}))
    }
  }

  render() {
    const { classes, patient } = this.props
    if (!patient) return <div/>
    return (
      <Drawer variant='permanent' classes={{ docked: classes.docked, paper: classes.drawer }}>
        <Typography className={classes.name}>
          {`${patient.firstName.charAt(0)} ${patient.lastName}`}
        </Typography>
        <MenuList>
          {
            Object.keys(tabs).map((tabName) => (
              <MenuItem button key={tabName} {...this.clickProps(tabName)} classes={{selected: classes.selected}}>
                 <ListItemIcon>
                  <Icon>{`${tabs[tabName].icon}`}</Icon>
                 </ListItemIcon>
                 <ListItemText className={classes.tabName} primary={humps.decamelize(tabName, { separator: ' '})} />
               </MenuItem>
            ))
          }
        </MenuList>
        <DeviceResetModal patient={patient} history={this.props.history}/>
      </Drawer>
    )
  }
}

export default withStyles(styles)(PatientSidebar)



// WEBPACK FOOTER //
// ./src/components/PatientSidebar.js